import { takeEvery, call, select } from 'redux-saga/effects'

import { doTrackEvent, doTrackLightbox } from './helpers'

import { ApiTypes, FrameTypes, SocketTypes, TrackingTypes } from '../../actions'

export function* trackAvailability() {
  const {
    Tracking: { availability },
  } = yield select()
  const event = { eventName: 'livechatAvailability', eventAction: 'livechat availability' }
  const name = 'livechatAvailability'
  const attributes = availability
  yield call(doTrackEvent, event, name, attributes)
}

export function* trackWindowActive() {
  const {
    Frame: { windowIsActive },
  } = yield select()
  const page = windowIsActive ? 'startChatWindow' : 'endChatWindow'
  yield call(doTrackLightbox, page)
}

export function* trackWindowMinimized() {
  const {
    Frame: { windowIsMinimized },
  } = yield select()

  let event
  let name

  if (windowIsMinimized) {
    event = { eventName: 'livechatMinimised', eventAction: 'livechat minimised' }
    name = 'livechatMinimised'
  } else {
    event = { eventName: 'livechatReopened', eventAction: 'livechat reopened' }
    name = 'livechatReopened'
  }

  yield call(doTrackEvent, event, name, '')
}

export function* trackWaitingRoom() {
  yield call(doTrackLightbox, 'waiting')
}

export function* trackWaitingRoomTooBusy() {
  yield call(doTrackLightbox, 'tooBusy')
}

export function* trackAgentConnected() {
  yield call(doTrackLightbox, 'agentConnected')
}

export function* trackBotConnected() {
  yield call(doTrackLightbox, 'botConnected')
}

export function* trackEndChatWindow() {
  yield call(doTrackLightbox, 'endChatWindow')
}

export function* trackCustomerEndedChat() {
  yield call(doTrackLightbox, 'customerEndedChat')
}

export function* trackAgentEndedChat() {
  yield call(doTrackLightbox, 'agentEndedChat')
}

export function* trackConnectionProblem() {
  yield call(doTrackLightbox, 'connectionProblem')
}

export function* trackAnswer({ trackingCode }) {
  yield call(doTrackLightbox, trackingCode)
}

export default [
  takeEvery(TrackingTypes.TRACK_AVAILABILITY, trackAvailability),
  takeEvery(FrameTypes.SET_CHAT_START_TIME, trackWindowActive),
  takeEvery(FrameTypes.TOGGLE_MINIMIZED, trackWindowMinimized),
  takeEvery(TrackingTypes.TRACK_WAITING_ROOM, trackWaitingRoom),
  takeEvery(TrackingTypes.TRACK_WAITING_ROOM_TOO_BUSY, trackWaitingRoomTooBusy),
  takeEvery(TrackingTypes.TRACK_AGENT_CONNECTED, trackAgentConnected),
  takeEvery(TrackingTypes.TRACK_BOT_CONNECTED, trackBotConnected),
  takeEvery(TrackingTypes.TRACK_END_CHAT_WINDOW, trackEndChatWindow),
  takeEvery(TrackingTypes.TRACK_CUSTOMER_ENDED_CHAT, trackCustomerEndedChat),
  takeEvery(TrackingTypes.TRACK_AGENT_ENDED_CHAT, trackAgentEndedChat),
  takeEvery(
    [TrackingTypes.TRACK_CONNECTION_PROBLEM, ApiTypes.CONTACT_CENTER_FAILURE, SocketTypes.SOCKET_CONNECT_FAILURE],
    trackConnectionProblem,
  ),
  takeEvery(TrackingTypes.TRACK_ANSWER, trackAnswer),
]
